import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AlertService } from '@service/alert.service';
import { AuthService } from '@service/auth.service';
import { DialogService } from '@service/dialog.service';
import { FireAnalyticsService } from '@service/fire-analytics.service';
import { Subject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
declare let cordova: any;

@Component({
    selector: 'app-user-menu',
    templateUrl: './user-menu.component.html',
    styleUrls: ['./user-menu.component.scss']
})

export class AppUserMenuComponent implements OnInit, OnDestroy {
    _unsubscribeAll: Subject<any> = new Subject();;
    currentUser: any = {};
    isLoggedIn = false;
    LoggedIn = true;
    notificationCount: any = 0;
    menuRef: any;
    isMobile: any = environment.app;
    version: any = environment.appVersion
    @Input() isAdvisor: boolean = false
    pendingProfileEnums = ['pan_verification', 'kyc', 'risk_profiling']
    pendingProfile: any;
    allVerticals: any;
    currentVertical: any

    constructor(
        private dialogRef: MatDialogRef<AppUserMenuComponent>,
        private router: Router,
        private auth: AuthService,
        public analytics: FireAnalyticsService,
        private dialogService: DialogService,
        private alertService: AlertService
    ) { }
    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
    ngOnInit() {
        this.currentVertical = window.localStorage.getItem('userVertical')
        this.auth.isLoggedIn.pipe(takeUntil(this._unsubscribeAll)).subscribe((res) => {
            this.isLoggedIn = res;
            if (this.isLoggedIn) this.userProfileSteps();
        });
        this.auth.userProfile.pipe(takeUntil(this._unsubscribeAll)).subscribe((res) => {
            this.currentUser = res;
        });

        // if (this.isLoggedIn && this.currentUser.id) {
        //     this.getNotificationCount();
        // }

        this.alertService.getVerticals().pipe(takeUntil(this._unsubscribeAll)).subscribe((res) => {
            if (res) {
                this.allVerticals = res;
            }
        })
    }

    getNotificationCount() {
        this.auth.notificationCount().subscribe((res) => {
            this.notificationCount = res.data.notificationCount
        })
    }

    logout() {
        this.closeMenu();
        this.analytics.logEvents('Logout Click')
        this.auth.logout();
    }

    openMobileMenu(template: any) {
        this.analytics.logEvents('Show User Menu')
        if (this.isLoggedIn) this.userProfileSteps();
        this.menuRef = this.dialogService.openTemplateDialog(template, { panelClass: 'sideSheet', maxWidth: '500px', position: { right: '0px' }, disableClose: false })
    }

    closeMenu(manualClose: boolean = false) {
        this.dialogRef.close(manualClose)
    }
    chatOnWhatApp() {
        this.analytics.logEvents('Chat With Us')
        if (environment.app) {
            cordova.InAppBrowser.open('https://wa.aisensy.com/3PYvrG', '_system', 'location=yes');
        } else {
            window.open('https://wa.aisensy.com/3PYvrG', '_blank')
        }
    }

    goTo(type: string) {
        if (type === 'transactions') {
            this.analytics.logEvents('Go To My Transaction')
            this.router.navigate(['/transactions'])
        } else if (type === 'rewards') {
            this.analytics.logEvents('Go To Rewards')
            this.router.navigate(['/my-rewards'])
        } else if (type === 'profile') {
            this.analytics.logEvents('Go To My Account')
            this.router.navigate(['/profile'])
        } else if (type === 'risk-profile') {
            this.storage()
            this.analytics.logEvents('Go To Risk Profile')
            this.router.navigate(['/profile-completion'])
        } else if (type === 'refer-earn') {
            this.analytics.logEvents('Go To Refer and Earn')
            this.router.navigate(['/refer-and-earn'])
        } else if (type === 'investment') {
            this.analytics.logEvents('Discover Investment')
            this.router.navigate(['/investment'])
        } else if (type === 'trading') {
            this.analytics.logEvents('Discover Trading')
            this.router.navigate(['/trading'])
        } else if (type === 'digital-savings') {
            this.analytics.logEvents('Discover Digital Savings')
            this.router.navigate(['/digital-savings'])
        } else if (type === 'mutual-funds') {
            this.analytics.logEvents('Discover Mutual Funds')
            this.router.navigate(['/mutual-funds'])
        } else if (type === 'login') {
            this.analytics.logEvents('Login Click')
            window.localStorage.setItem('loginRequired', "true");
            this.router.navigate(['/login']);
        } else if (type === 'faq') {
            this.analytics.logEvents('Go To FAQ')
            this.router.navigate(['/help-and-support'])
        } else if (type === 'products') {
            this.analytics.logEvents('View All Pickright Products')
            this.router.navigate(['/products'])
        } else if (type === 'crypto') {
            this.analytics.logEvents('Discover CryptoCurrency')
            this.router.navigate(['/cryptocurrency'])
        } else if (type === 'financial-plan') {
            this.analytics.logEvents('Discover Financial Planning')
            // this.router.navigate(['/customized-financial'])
            window.open('https://docs.google.com/forms/d/e/1FAIpQLScWTFvBDwiYSrp27YJSjLEPMjcGx_RzMwIZ40Yek2TeijbvGQ/viewform', '_blank')
        }
        this.closeMenu()
    }

    openNotificationDialog() {
        this.closeMenu()
        this.analytics.logEvents('Show Notifications', { action: 'Open' })
    }

    userProfileSteps() {
        this.auth.getUserprofileJourney().subscribe((res) => {
            if (res.data) {
                let inComplete = res.data.find((x) => !x.isCompleted && this.pendingProfileEnums.indexOf(x.name) > -1)
                if (inComplete) this.pendingProfile = inComplete;
            }
        })
    }

    storage() {
        window.sessionStorage.setItem('currentPage', this.router.url)
        if (window.sessionStorage.getItem('SubscribingPack')) {
            window.sessionStorage.removeItem('SubscribingPack')
        }
        if (window.sessionStorage.getItem('agreedSign')) {
            window.sessionStorage.removeItem('agreedSign')
        }
    }
}